import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=5508f725&scoped=true"
import script from "./Feedback.js?vue&type=script&lang=js&external"
export * from "./Feedback.js?vue&type=script&lang=js&external"
import style0 from "./Feedback.scss?vue&type=style&index=0&id=5508f725&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5508f725",
  null
  
)

export default component.exports